import './customDrawer.module.scss';
import {
  AnimatePresence,
  motion,
  useMotionValue,
  useTransform,
} from 'framer-motion';
import Portal from '../portal';
import useSetDrawer from './hooks/useSetDrawer';

const CustomDrawer = ({
  isOpen,
  children,
  onDismiss,
  anchor,
}: ICustomDrawerProps) => {
  const dragY = useMotionValue(0);
  const sheetY = useTransform(
    dragY,
    [0, window.innerHeight],
    [0, window.innerHeight],
  );
  const {handleDragEnd} = useSetDrawer(isOpen, onDismiss);

  return (
    <Portal>
      <AnimatePresence>
        {isOpen && (
          <>
            <motion.div
              initial={{opacity: 0}}
              animate={{opacity: 0.5}}
              exit={{opacity: 0}}
              transition={{duration: 0.3}}
              className="position-fixed inset-0 bg-dark z-40 "
              onClick={onDismiss}
            />
            <motion.div
              initial={{translateY: '100%', opacity: 0}}
              animate={{translateY: '0%', opacity: 1}}
              exit={{translateY: '100%', opacity: 0}}
              transition={{duration: 0.3}}
              className="position-fixed bottom-0 end-0 w-100 bg-white shadow  p-4 rounded-top"
              style={{y: sheetY}}
              drag="y"
              dragConstraints={{top: 0, bottom: 0}}
              onDragEnd={handleDragEnd}
              dragElastic={0.2}
            >
              {children}
            </motion.div>
          </>
        )}
      </AnimatePresence>
    </Portal>
  );
};

export default CustomDrawer;
